import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MoneyFormatService {

    constructor() { }

    /**
     * Formats a number as a string with thousands separators.
     * By default, it uses the 'en-US' locale to ensure comma separators (e.g. 12,000).
     * @param value The number or string to format.
     * @param minimumFractionDigits The minimum number of decimal places (default: 2).
     * @param maximumFractionDigits The maximum number of decimal places (default: 2).
     */
    format(value: string | number | null | undefined, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        // Convert string to number if needed
        const numValue = typeof value === 'string' ? parseFloat(value) : value;

        // Check if conversion resulted in a valid number
        if (isNaN(numValue)) {
            return '';
        }

        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
        }).format(numValue);
    }

    /**
     * Formats a number as an integer with thousands separators (e.g. 12,000).
     * @param value The number or string to format.
     */
    formatInteger(value: string | number | null | undefined): string {
        return this.format(value, 0, 0);
    }
}
